export const COLUMN_HEIGHT = 224;
export const ITEM_HEIGHT = 32;
export const PERIODS = ["AM", "PM"] as const;

export const SIZE_CONFIG = {
  small: {
    trigger: "h-8 md:h-7",
    input: "text-base md:text-xs",
    icon: "size-3.5",
  },
  medium: {
    trigger: "h-8",
    input: "text-base md:text-sm",
    icon: "size-4",
  },
  large: {
    trigger: "h-10",
    input: "text-base md:text-sm",
    icon: "size-5",
  },
} as const;
